import { getDataSource, getMe } from 'legacy/store/appReducer';
import { DATASOURCES } from 'legacy/constants';

// URL functions
import { postKardiaRxIdtfEcgConfirm } from 'legacy/containers/ApiUrls';

// Constants Types
import {
  IDTF_ECG_CONFIRM_REQUEST,
  IDTF_ECG_CONFIRM_SUCCESS,
  IDTF_ECG_CONFIRM_FAILURE,
} from './types';

// ------------------------------------
// Actions
// ------------------------------------
export const kRxconfirmRecordingRequest = () => ({
  type: IDTF_ECG_CONFIRM_REQUEST,
});
export const kRxconfirmRecordingSuccess = data => ({
  type: IDTF_ECG_CONFIRM_SUCCESS,
  payload: data,
});
export const kRxconfirmRecordingFailure = err => ({
  type: IDTF_ECG_CONFIRM_FAILURE,
  payload: err,
});

export const confirmEcg = selectedRecordingId => (dispatch, getState) => {
  dispatch(kRxconfirmRecordingRequest());
  const meDataSource = getDataSource(getState(), DATASOURCES.ME);

  dispatch(postKardiaRxIdtfEcgConfirm(selectedRecordingId))
    .then(() => dispatch(kRxconfirmRecordingSuccess()))
    .catch(err => dispatch(kRxconfirmRecordingFailure(err)));
};



// WEBPACK FOOTER //
// ./src/views/state/kardiaRxIdtf/KardiaRxIDTFEcgConfirmActions.js